// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'organizations'"
        editRoute="organizationEdit"
        :headers="headers"
        name="Organization"
        :searchBarText="searchBarText"
        permissions="organizations"
        ></item-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ItemList from 'vue-common/components/ItemList.vue'

import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Subdomain',
          value: 'subdomain'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Organizations.vue